import { atom } from 'recoil';

export const ShowTimeLineState = atom({
    key: 'ShowTimeLineState', 
    default: false, 
});